import Image from 'next/image';

import { cn } from '@/lib/utils';

type GlowThumbnailProps = {
	src: string;
	alt: string;
	width: number;
	height: number;
	/** `lg` grows to 440px on desktop; mobile stays at the 352px thumbnail size. */
	size?: 'md' | 'lg';
	className?: string;
};

/**
 * First-fold image at the landing page's demo-thumbnail size (352px) with the
 * same blue radial glow behind it (see product-demo-video.tsx). Used by the
 * /free-ats and /mcp heroes so both match the home page's first fold.
 */
export const GlowThumbnail = ({
	src,
	alt,
	width,
	height,
	size = 'md',
	className,
}: GlowThumbnailProps) => (
	<div
		className={cn('relative w-full max-w-[352px]', size === 'lg' && 'md:max-w-[440px]', className)}
	>
		<div
			aria-hidden="true"
			className="pointer-events-none absolute left-1/2 top-[36%] z-0 h-[min(100vw,48rem)] w-[min(100vw,48rem)] -translate-x-1/2 -translate-y-1/2 bg-[radial-gradient(circle_at_center,rgb(37_99_235_/_0.32)_0%,rgb(59_130_246_/_0.14)_36%,transparent_74%)]"
		/>
		<div className="relative z-[1] w-full overflow-hidden rounded-xl border border-slate-200 bg-white">
			<Image
				src={src}
				alt={alt}
				width={width}
				height={height}
				priority
				sizes={size === 'lg' ? '(min-width: 768px) 440px, 352px' : '352px'}
				className="h-auto w-full object-contain"
			/>
		</div>
	</div>
);
